import { axiosInstance } from 'api/instance';
import { zoneEndpoints } from './zone.endpoints';

const getZone = () => axiosInstance.get(zoneEndpoints.zone());

export const zoneRequests = {
  getZone
};
